import { render, staticRenderFns } from "./HelfenMappingRows.vue?vue&type=template&id=0dec24e0&"
import script from "./HelfenMappingRows.vue?vue&type=script&lang=js&"
export * from "./HelfenMappingRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports